import React, {FC} from 'react';
import styled from 'styled-components';
import {useHtmlDir} from '../../../LegacyWebCoreConfigContext';
import {createHelpCenterArticleUrl} from '../../../pages/HelpCenter/routes';
import {HelpCenterLandingPageData} from '../../../pages/HelpCenter/types';
import NavigationCard from '../../Card/NavigationCard';
import {primaryColor} from '../../constants/colors';
import {
  mediaMinDesktop,
  mediaMinDesktopLarge,
  mediaMinTablet,
  minTabletOnlyCss,
} from '../../constants/customMedia';
import {fsL, fsM, fsXL, fwBold} from '../../constants/typography';

interface DesktopFrequentQuestionsProps {
  title: string;
  frequentQuestions: HelpCenterLandingPageData['highlightArticles'];
}

export const DesktopFrequentQuestions: FC<DesktopFrequentQuestionsProps> = ({
  frequentQuestions,
  title,
}) => {
  const isRtlHtmlDir = useHtmlDir() === 'rtl';
  return (
    <SectionWrapper tabletOnly>
      {/* Do we need a data-testid here? */}
      <Title>{title}</Title>
      <HeaderLinks data-testid="HelpCenterTeaserPromotedArticlesContainerLargeScreen">
        {frequentQuestions.map(({section, article}) => (
          <NavigationCard
            bold
            dataTestId="HelpCenterTeaserPromotedArticle"
            label={article.name}
            to={createHelpCenterArticleUrl(section, article)}
            key={`${article.id}_desktop`}
            isRtl={isRtlHtmlDir}
          />
        ))}
      </HeaderLinks>
    </SectionWrapper>
  );
};

const SectionWrapper = styled.div<{tabletOnly?: boolean}>`
  margin-bottom: 40px;
  ${({tabletOnly}) => tabletOnly && minTabletOnlyCss}
`;

const Title = styled.h3`
  font-size: ${fsM}px;
  ${fwBold};
  line-height: 1.33;
  text-align: center;
  color: ${primaryColor};
  padding-bottom: 15px;

  @media ${mediaMinTablet} {
    font-size: ${fsL}px;
    padding-bottom: 40px;
  }
  @media ${mediaMinDesktopLarge} {
    font-size: ${fsXL}px;
  }
`;

const HeaderLinks = styled.div`
  display: none;
  justify-content: center;
  width: 100%;
  & > a {
    width: 248px;
    max-width: 30%;
  }

  @media ${mediaMinTablet} {
    display: flex;
    & > a:nth-child(1) {
      margin-right: 20px;
    }
    & > a:nth-child(n + 3) {
      display: none;
    }
  }
  @media ${mediaMinDesktop} {
    display: flex;

    & > a:nth-child(2) {
      margin-right: 20px;
    }
    & > a:nth-child(n + 3) {
      display: flex;
    }
    & > a:nth-child(n + 4) {
      display: none;
    }
  }
  @media ${mediaMinDesktopLarge} {
    display: flex;
    & > a:nth-child(3),
    & > a:nth-child(4) {
      margin-right: 20px;
    }
    & > a:nth-child(n + 4) {
      display: flex;
    }
    & > a:nth-child(n + 6) {
      display: none;
    }
  }
`;
